export default {
	selected_language(state) {
		return state.selected_language
	},
}
